import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Alert,
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

const EditFolderModal = ({ 
  open, 
  onClose, 
  onSubmit, 
  folder 
}) => {
  const [folderName, setFolderName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  
  useEffect(() => {
    if (folder) {
      setFolderName(folder.name || '');
      setDescription(folder.description || '');
    }
  }, [folder]);
  
  const handleSubmit = () => {
    // Validation
    if (!folderName.trim()) {
      setError('Folder name is required');
      return;
    }
    
    if (folderName.length > 100) {
      setError('Folder name must be less than 100 characters');
      return;
    }
    
    // Submit the updated folder data
    onSubmit({
      ...folder,
      name: folderName.trim(),
      description: description.trim(),
    });
    
    // Reset form
    handleClose();
  };
  
  const handleClose = () => {
    setFolderName('');
    setDescription('');
    setError('');
    onClose();
  };
  
  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <EditIcon sx={{ mr: 1 }} />
          Edit Folder
        </Box>
      </DialogTitle>
      
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        <TextField
          autoFocus
          margin="dense"
          label="Folder Name"
          fullWidth
          variant="outlined"
          value={folderName}
          onChange={(e) => {
            setFolderName(e.target.value);
            setError('');
          }}
          required
          helperText={`${folderName.length}/100 characters`}
          sx={{ mb: 2 }}
        />
        
        <TextField
          margin="dense"
          label="Description (Optional)"
          fullWidth
          variant="outlined"
          multiline
          rows={3}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          helperText="Brief description of what this folder contains"
        />
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained"
          disabled={!folderName.trim()}
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditFolderModal;